/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

/* AUTH */
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNUP_USER_ERROR = "SIGNUP_USER_ERROR";
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNIN_USER_ERROR = "SIGNIN_USER_ERROR";
export const OTP_USER = "OTP_USER";
export const OTP_USER_SUCCESS = "OTP_USER_SUCCESS";
export const OTP_USER_ERROR = "OTP_USER_ERROR";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

/* ORGANIZATION */
export const SIGNUP_ORGANIZATION = "SIGNUP_ORGANIZATION";
export const SIGNUP_ORGANIZATION_SUCCESS = "SIGNUP_ORGANIZATION_SUCCESS";
export const SIGNUP_ORGANIZATION_ERROR = "SIGNUP_ORGANIZATION_ERROR";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_ORGANIZATION_ERROR = "GET_ORGANIZATION_ERROR";
export const UPDATE_ORGANIZATION_ADDRESS = "UPDATE_ORGANIZATION_ADDRESS";

/* TAG */
export const GET_TAGS = "GET_TAGS";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";
export const ADD_TAG = "ADD_TAG";
export const ADD_TAG_SUCCESS = "ADD_TAG_SUCCESS";
export const ADD_TAG_ERROR = "ADD_TAG_ERROR";
export const REMOVE_TAG = "REMOVE_TAG";
export const REMOVE_TAG_SUCCESS = "REMOVE_TAG_SUCCESS";
export const REMOVE_TAG_ERROR = "REMOVE_TAG_ERROR";

export const GET_IMAGE = "GET_IMAGE";
export const GET_IMAGE_SUCCESS = "GET_IMAGE_SUCCESS";
export const GET_IMAGE_ERROR = "GET_IMAGE_ERROR";
export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_ERROR = "UPLOAD_IMAGE_ERROR";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

export * from "./auth/actions";
export * from "./org/actions";
export * from "./tag/actions";
export * from "./menu/actions";
export * from "./settings/actions";
